module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wm-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外管消息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wm-card"
  }, [_c('div', {
    staticClass: "wm-tabs"
  }, [_c('div', {
    staticClass: "wm-tab",
    class: {
      'wm-tab--active': _vm.activeTab === 'send'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('send')
      }
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('div', {
    staticClass: "wm-tab",
    class: {
      'wm-tab--active': _vm.activeTab === 'history'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('history')
      }
    }
  }, [_vm._v("\n        发送记录"), _c('span', {
    staticClass: "wm-badge"
  }, [_vm._v(_vm._s(_vm.recordCount))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'send'),
      expression: "activeTab === 'send'"
    }],
    staticClass: "wm-send"
  }, [_c('div', {
    staticClass: "wm-form-row"
  }, [_c('label', {
    staticClass: "wm-form-label"
  }, [_vm._v("接收对象")]), _vm._v(" "), _c('Select', {
    staticClass: "wm-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "on-change": _vm.sendTypeChange
    },
    model: {
      value: (_vm.formData.sendType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sendType", _vm._n($$v))
      },
      expression: "formData.sendType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("全体中教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("全体外教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("个人中教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("个人外教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("全体陪练老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("个人陪练老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("全部老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 8
    }
  }, [_vm._v("欧美外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 9
    }
  }, [_vm._v("菲教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("指定老师")])], 1)], 1), _vm._v(" "), (_vm.showTch) ? _c('div', {
    staticClass: "wm-form-row"
  }, [_c('Select', {
    staticClass: "wm-select",
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.tchIds),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchIds", $$v)
      },
      expression: "formData.tchIds"
    }
  }, _vm._l((_vm.tchList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-form-row"
  }, [_c('label', {
    staticClass: "wm-form-label"
  }, [_vm._v("消息内容")]), _vm._v(" "), _c('Input', {
    staticClass: "wm-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "输入要发送的消息"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.buttonLoading ? '发送中…' : '发 送'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'history'),
      expression: "activeTab === 'history'"
    }],
    staticClass: "wm-history"
  }, [(_vm.listLoading) ? _c('div', {
    staticClass: "wm-empty"
  }, [_vm._v("加载中…")]) : _c('table', {
    staticClass: "wm-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.records.length) ? _c('tr', [_c('td', {
    staticClass: "wm-empty-cell",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无发送记录")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.records), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('td', {
      staticClass: "wm-msg-cell",
      attrs: {
        "title": row.content
      }
    }, [_vm._v(_vm._s(row.content))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "wm-tag",
      class: _vm.isAllLike(row.sendType) ? 'wm-tag-all' : 'wm-tag-part'
    }, [_vm._v(_vm._s(row.targetLabel || _vm.sendTypeLabel(row.sendType)))]), _vm._v(" "), (row.resent == 1) ? _c('span', {
      staticClass: "wm-tag wm-tag-resend"
    }, [_vm._v("已追发")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(_vm.formatTime(row.gmtCreate)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(_vm.formatNum(row.totalCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num wm-read"
    }, [_vm._v(_vm._s(_vm.formatNum(row.readCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num",
      class: row.unreadCount > 0 ? 'wm-unread' : ''
    }, [_vm._v(_vm._s(row.unreadCount > 0 ? _vm.formatNum(row.unreadCount) : '—'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "wm-rate-bar"
    }, [_c('i', {
      style: ({
        width: (row.readRate || 0) + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(row.readRate || 0) + "%")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "wm-btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openDetail(row)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), (row.unreadCount > 0) ? _c('button', {
      staticClass: "wm-btn-link wm-warn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openResend(row)
        }
      }
    }, [_vm._v("对未读人再次发送")]) : _c('span', {
      staticClass: "wm-all-read"
    }, [_vm._v("全部已读")])])])
  })], 2)]), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "wm-pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.pageNum,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wm-mask",
    class: {
      show: _vm.detailVisible
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.detailVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "wm-modal",
    staticStyle: {
      "width": "520px"
    }
  }, [_c('div', {
    staticClass: "wm-modal-head"
  }, [_vm._v("消息详情 "), _c('span', {
    staticClass: "wm-modal-close",
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.detail) ? _c('div', {
    staticClass: "wm-modal-body"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('b', [_vm._v("消息内容：")]), _vm._v(_vm._s(_vm.detail.content))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "12px",
      "color": "#888"
    }
  }, [_vm._v("发送对象：" + _vm._s(_vm.detail.targetLabel || _vm.sendTypeLabel(_vm.detail.sendType)) + " ｜ 发送时间：" + _vm._s(_vm.formatTime(_vm.detail.gmtCreate)))]), _vm._v(" "), _c('div', {
    staticClass: "wm-stat-line"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formatNum(_vm.detail.totalCount)))]), _vm._v("发送人数")]), _vm._v(" "), _c('div', [_c('b', {
    staticStyle: {
      "color": "#52c41a"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.detail.readCount)))]), _vm._v("已读")]), _vm._v(" "), _c('div', [_c('b', {
    staticStyle: {
      "color": "#fa541c"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.detail.unreadCount)))]), _vm._v("未读")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "6px",
      "color": "#888"
    }
  }, [_vm._v("老师阅读明细：")]), _vm._v(" "), _c('div', {
    staticClass: "wm-teacher-list"
  }, [_vm._l((_vm.detail.teachers), function(t) {
    return _c('div', {
      key: t.tchId + '-' + t.status,
      staticClass: "wm-teacher-row"
    }, [_c('span', [_vm._v(_vm._s(t.tchName))]), _vm._v(" "), _c('span', {
      class: t.status == 1 ? 'wm-st-read' : 'wm-st-unread'
    }, [_vm._v(_vm._s(t.statusLabel || (t.status == 1 ? '已读' : '未读')))])])
  }), _vm._v(" "), (!_vm.detail.teachers || !_vm.detail.teachers.length) ? _c('div', {
    staticStyle: {
      "padding": "12px",
      "color": "#999"
    }
  }, [_vm._v("暂无明细")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-modal-foot"
  }, [_c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关 闭")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wm-mask",
    class: {
      show: _vm.resendVisible
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resendVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "wm-modal",
    staticStyle: {
      "width": "440px"
    }
  }, [_c('div', {
    staticClass: "wm-modal-head"
  }, [_vm._v("对未读老师再次发送 "), _c('span', {
    staticClass: "wm-modal-close",
    on: {
      "click": function($event) {
        _vm.resendVisible = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.resendRow) ? _c('div', {
    staticClass: "wm-modal-body"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("即将向本条消息的 "), _c('b', {
    staticStyle: {
      "color": "#fa541c"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.resendRow.unreadCount)) + " 位未读老师")]), _vm._v(" 再次发送：")]), _vm._v(" "), _c('div', {
    staticClass: "wm-resend-box"
  }, [_vm._v(_vm._s(_vm.resendRow.content))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("已读老师不会收到重复消息。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-modal-foot"
  }, [_c('button', {
    staticClass: "wm-btn wm-btn-ghost",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resendVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.resendLoading
    },
    on: {
      "click": _vm.confirmResend
    }
  }, [_vm._v(_vm._s(_vm.resendLoading ? '发送中…' : '确认发送'))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("消息内容")]), _vm._v(" "), _c('th', [_vm._v("发送对象")]), _vm._v(" "), _c('th', [_vm._v("发送时间")]), _vm._v(" "), _c('th', [_vm._v("发送人数")]), _vm._v(" "), _c('th', [_vm._v("已读")]), _vm._v(" "), _c('th', [_vm._v("未读")]), _vm._v(" "), _c('th', [_vm._v("阅读率")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15afef88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TeacherManagerMessage.vue
// module id = 1642
// module chunks = 8